import useMutationApi from '../useMutationApi';
import { QuoteSheetLineItemDTO } from './quote-sheets-types';

interface RejectQuoteSheetMatchRequest {
  lineItemId: string;
}

interface RejectQuoteSheetMatchResponse {
  success: boolean;
  data?: QuoteSheetLineItemDTO;
  error?: string;
}

export function useRejectQuoteSheetMatch() {
  return useMutationApi<
    RejectQuoteSheetMatchRequest,
    RejectQuoteSheetMatchResponse
  >({
    endpoint: 'accounts-payable/quote-sheet-matching/reject-match',
    method: 'POST',
    successMessage: 'Match rejected successfully',
    errorMessage: 'Failed to reject match',
    showSuccessToast: true,
    showErrorToast: true,
  });
}
